import { useSelector, useDispatch } from 'react-redux';
import { Spin } from 'antd'
import './index.css'

export default function Index(props: any) {
    const isLoading = useSelector((state: any) => state.common.isLoading);
    return (<div className={`m-loading-wrap ${isLoading ? 'active' : ''}`}><Spin /></div>)
}